<template>
	<div style="position: relative;">
		<div class="form-horizontal mt-4" tabindex="-2" ref="profileErrors">
			<div v-if="errors.length" class="alert alert-warning ks-solid-light ks-active-border">
				<p>
					<b>Please correct the following error(s):</b>
					<ul>
					<li v-for="error in errors">{{ error }}</li>
					</ul>
				</p>
			</div>

			<div class="form-group row">
				<label for="name" class="col-md-3 col-form-label text-right">Name</label>
				<div class="col-md-9">
					<input type="text" :disabled="!canCreateOrEdit" name="name" v-model="currentPriceProfile.name" class="form-control" />
				</div>
			</div>
			<div class="form-group row">
				<label for="priority" class="col-md-3 col-form-label text-right">Priority</label>
				<div class="col-md-9">
					<input type="number" step="1" :disabled="!canCreateOrEdit" name="priority" v-model="currentPriceProfile.priority" class="form-control" />
				</div>
			</div>
			<div class="form-group row">
				<label for="price_base" class="col-md-3 col-form-label text-right">Base</label>
				<div class="col-md-9">
					<input type="text" :disabled="!canCreateOrEdit" name="price_base" v-model="currentPriceProfile.price_base" class="form-control" />
				</div>
			</div>

			<div class="form-group row price-tiers">
				<div class="col-md-9 ml-auto">
					<div v-if="canCreateOrEdit && this.mode == null" class="header-block clearfix">
						<h4 class="pull-left">Price Tiers</h4>
						<button
							@click="addPriceTier()"
							type="button"
							class="btn btn-sm btn-primary pull-right"
							data-toggle="collapse"
							data-target="#create_price_tier"
						>Add Price Tier</button>
					</div>
					<div v-if="tierErrors.length" tabindex="-1"  ref="tierErrors" class="alert alert-warning ks-solid-light ks-active-border">
						<p>
							<b>Please correct the following error(s):</b>
							<ul>
							<li v-for="error in tierErrors">{{ error }}</li>
							</ul>
						</p>
					</div>
					<div id="create_price_tier" class="collapse">
						<div class="form-group row">
							<label for="tier-name" class="col-md-3 col-form-label text-right">Price Tier Name</label>
							<div class="col-md-9">
								<input type="text" name="tier-name" v-model="currentTier.name" class="form-control" />
							</div>
						</div>
						<div class="form-group row">
							<label for="minimum_qty" class="col-md-3 col-form-label text-right">Starting Quantity</label>
							<div class="col-md-9">
								<input type="number" step="1" name="minimum_qty" v-model="currentTier.minimum_qty" class="form-control" />
							</div>
						</div>
						<div class="form-group row">
							<label for="amount" class="col-md-3 col-form-label text-right">Discount %</label>
							<div class="col-md-9">
								<input type="number" name="amount" v-model="currentTier.amount" class="form-control" />
							</div>
						</div>
						<div class="form-group row">
							<label for="cost" class="col-md-3 col-form-label text-right">Customer Discount %</label>
							<div class="col-md-9">
								<input type="number" name="cost" v-model="currentTier.cost" class="form-control" />
							</div>
						</div>
						<div class="form-group row">
						<div class="col-md-9 ml-auto">
							<button
								@click="saveTier()"
								class="btn btn-primary btn-sm"
								type="button">
								{{ this.isTierEdit ? "Save" : "Create" }}</button>
							<button
								@click="cancelTierEdition()"
								type="button"
								class="btn btn-sm btn-secondary"
								data-toggle="collapse"
								data-target="#create_price_tier"
							>Cancel</button>
						</div>
					</div>
				</div>
					<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
						<vuetable
							ref="vuetable"
							:api-mode="false"
							:data-manager="dataManager"
							:fields="fields"
							:css="css.table"
							noDataTemplate="No Price Tiers Found"
							:append-params="moreParams"
							@vuetable:loaded="onLoaded"
						>
							<template v-if="canCreateOrEdit" slot="actions" slot-scope="props" >
								<div class="d-flex" v-if="!mode">
									<a
										class="btn btn-outline-danger"
										@click="deletePriceTier(props.rowData)"
									>Delete</a>
									<a
										data-toggle="collapse"
										data-target="#create_price_tier"
										class="btn btn-outline-primary" @click="editPriceTier(props.rowData)"
									>Edit</a>
								</div>
							</template>
						</vuetable>
					</div>
				</div>
			</div>

			<div class="form-group row" v-if="canCreateOrEdit">
				<div class="col-md-9 ml-auto">
					<button class="btn btn-primary" @click="saveProfile">{{ isEdit ? 'Save' : 'Create' }}</button>
					<button v-if="!isEdit"
						type="button"
						class="btn btn-secondary"
						@click="cancelProfileCreation"
					>Cancel</button>
					<a v-else
						type="button"
						class="btn btn-secondary"
						:href="this.priceProfile ? '/pricing-profiles' : '#'"
					>Cancel</a>

					<button v-if="isEdit && showActivityLog"  type="button" class="btn btn-secondary" @click.stop="showActivityLog = false">Hide Activity Log</button>
                    <button v-else-if="isEdit && !showActivityLog"  type="button" class="btn btn-secondary" @click.stop="showActivityLog = true">Show Activity Log</button>
				</div>
			</div>
		</div>
		<div class="m-4" v-if="showActivityLog">
            <div class="row">
                <div class="col-md-12">
                    <h3 class="card-title">Price Profile Activity Log</h3>
                </div>
            </div>
            <div class="row mt-0 mb-0 p-0">
                <div class="offset-1 col-md-11">
                    <activity-log entity-type="price_profiles" :entity-id="priceProfile.id" ref="activityLog"></activity-log>
                </div>
            </div>
        </div>
	</div>
</template>

<style scoped lang="scss">

#create_price_tier {
	margin-top: 25px;
}

.price-tiers {
	background-color: #ededed;
	border: 1px solid lightgrey;
    padding: 20px;
}
.mr7 {
	margin-right: 7px;
}
.mr2 {
	margin-right: 2px;
}
.table-button-container {
	text-align: center;
}
.channel-container {
	position: relative;
	.channel-expander {
		background: #25628f;
		z-index: 2;
		width: 16px;
		height: 16px;
		border-radius: 50%;
		color: #fff;
		position: absolute;
		text-align: center;
		right: 5px;
		bottom: 3px;
		font-size: 10px;
		padding-top: 1px;
		&:before {
			content: "\F110";
			font: normal normal normal 14px/1 "LineAwesome";
			color: #fff;
			font-size: 10px;
		}
		&.open {
			&.scrolled {
				right: 7px;
			}
			&:before {
				content: "\f113";
			}
		}
	}
}
.channel-item-container {
	transition: all 0.3s;
	z-index: 1;
	max-height: 59px;
	min-height: 59px;
	overflow: hidden;
	&.open {
		transition: all 0.5s;
		max-height: 199px;
		&.scrolled {
			overflow-y: overlay;
		}
	}
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-track {
		background: rgba(0, 0, 0, 0.1);
		position: absolute;
		top: 0px;
		bottom: 0px;
		right: 0px;
	}
	&::-webkit-scrollbar-thumb {
		background: #25628f;
		border-radius: 2px;
	}
	&::-webkit-scrollbar-thumb:hover {
		background: #25628f;
	}
}
.channel-item {
	// border-bottom:1px solid #dee0e1;
	padding: 2px 7px;
	font-size: 10px;
	position: relative;
	&:nth-child(n + 3):last-child {
		border-color: transparent;
	}
}
.no-channel {
	text-align: center;
	padding: 20px 0;
}
* {
  scroll-margin-top: 100px;
}
</style>

<script type="text/javascript">

import Vue from 'vue';
import VueEvents from 'vue-events'
import _ from "lodash";
import modeEnum from './mode.ts';
import Axios from 'axios';
import ActivityLog from '../activity/activity.vue';

Vue.use(VueEvents)

export default {
	name: 'pricing-profile-form',
	props: [ 'priceProfile', 'permissions'],
	components: {
		'activity-log': ActivityLog,
	},
	data() {
		return {
			showActivityLog: false,
			errors: [],
			tierErrors: [],
			currentPriceProfile: {},
			mode: null,
			currentTier: {},
			moreParams: {},
			loading: true,
			fields: [
				{
					title: 'Name',
					name: 'name',
				},
				{
					title: 'Starting Quantity',
					name: 'minimum_qty'
				},
				{
					title: 'Discount %',
					name: 'amount'
				},
				{
					title: 'Customer Discount %',
					name: 'cost'
				},
				{
					name: '__slot:actions',
					titleClass: 'actions-single-column'
				},
			],
			css: {
				table: {
					tableClass: 'table table-striped table-bordered table-middle',
					ascendingIcon: 'sort-icon-asc',
					descendingIcon: 'sort-icon-desc',
					infoClass: '', 
				},
			},
		}
	},
	mounted() {
		this.currentPriceProfile = _.cloneDeep(this.priceProfile ? this.priceProfile : {});
		this.refreshTiers();
	},
	computed: {
		tiers(){
			return this.currentPriceProfile.tiers;
		},
		isEdit() {
			return this.priceProfile != null;
		},
		isTierEdit() {
			return this.currentTier.id ||  this.currentTier.tempId;
		},
		canCreateOrEdit() {
			return this.isEdit ? this.permissions.canEdit : this.permissions.canCreate; 
		}
	},
	watch: {
	},
	methods: {
		async saveProfile() {
			let errorContainer = "profileErrors";

			showProcessing();
			if(this.isEdit) {
				Axios.post(this.updateUrl(this.currentPriceProfile.id), this.currentPriceProfile).then(r => {
					this.back();
				}, r => {
					hideProcessing();
					if(r.response && r.response.data) {
						this.fillErrorsFromResponse(r.response, errorContainer);
					}
				});
			}
			else {
				Axios.post(this.storeUrl(this.currentPriceProfile)).then(r => {
					this.back()
				}, r => {
					hideProcessing();
					if(r.response && r.response.data) {
						this.fillErrorsFromResponse(r.response, errorContainer);
					}
				});
			}
		},
		async checkTierForm(e) {
			this.tierErrors = [];
			let requestTiers = [ this.currentTier ].concat(this.isTierEdit ? this.getOtherTiers() : this.currentPriceProfile.tiers); 
			
			await Axios.post(route('pricing_profiles.tiersValidation'), { tiers: requestTiers }).then(r => {}, r => {
				if(r.response && r.response.data) {
					this.fillErrorsFromResponse(r.response, "tierErrors")
				}
			});
		},
		async saveTier() {
			showProcessing();
			await this.checkTierForm();
			hideProcessing();

			if(this.tierErrors.length === 0) 
			{
				let selectedTier = this.getSelectedTier();
	
				if (selectedTier) {
					let ppIndex = this.currentPriceProfile.tiers.indexOf(selectedTier);
					this.currentPriceProfile.tiers[ppIndex] = this.currentTier;
				}
				else {
					this.currentTier.tempId = "temp#" + this.currentPriceProfile.tiers.length;
					this.currentPriceProfile.tiers.push(_.clone(this.currentTier));
				}
				this.currentTier = {};
				this.mode = null;
				$('#create_price_tier').collapse('hide');
				this.refreshTiers();
			} 
			else 
			{
				this.goto('tierErrors');
			}
		},
		fillErrorsFromResponse(response, errorContainer) {
			let errorsBag = errorContainer === "profileErrors" ? this.errors : this.tierErrors;
			errorsBag.length = 0;
			let errors = response.data;

			if(response.status === 400) 
			{
				Object.entries(errors).forEach(p => {
					let errorTxt = p[1][0];
					if(errorsBag.indexOf(errorTxt) === -1) 
					{
						errorsBag.push(errorTxt);
					}
				});
			}
			else {
				errorsBag.push("An unexpected error has occurred. Please, try again later")
			}
			this.goto(errorContainer);
		},
		getOtherTiers() {
			return this.currentPriceProfile.tiers.filter(t => t.id ? t.id !== this.currentTier.id : t.tempId !== this.currentTier.tempId);
		},
		getSelectedTier() {
			return this.currentPriceProfile.tiers.find(pp => pp.id ? pp.id == this.currentTier.id : pp.tempId == this.currentTier.tempId);
		},
		deletePriceTier(priceTier) {
			let i = this.currentPriceProfile.tiers.indexOf(priceTier);
			this.currentPriceProfile.tiers.splice(i,1);
		},
		editPriceTier(priceTier) {
			this.mode = modeEnum.Edit;
			this.currentTier = _.clone(priceTier);
		},
		addPriceTier() {
			if(!this.currentPriceProfile.tiers)
			{
				this.currentPriceProfile.tiers = [];
			}
			this.mode = modeEnum.Create;
		},
		cancelTierEdition() {
			this.mode = null;
			this.currentTier = {};
			this.tierErrors = [];
		},
		cancelProfileCreation() {
			this.currentPriceProfile = {};
			this.errors = [];
			$('#create_record').collapse('hide'); //This container is the component wrapper
		},
		//Grid
		dataManager (sortOrder, pagination) {
			return {
				pagination: pagination,
				data: this.orderedTiers()
			};
		},
		refreshTiers() {
			this.$refs.vuetable.refresh();
		},
		orderedTiers() {
			return this.currentPriceProfile.tiers 
				? this.currentPriceProfile.tiers.sort((a, b) => (a.minimum_qty > b.minimum_qty) ? 1 : -1)
				: []
		},
		//Navigation
		updateUrl(id) {
			return route('pricing-profiles.update', id);
		},
		storeUrl(id) {
			return route('pricing_profiles.store', id);
		},
		goto(refName) {
			this.$nextTick(function(){
				var element = this.$refs[refName];
				element.scrollIntoView({behavior: "smooth"})
			});
		},
		back() {
			window.location.href = route('pricing_profiles.index');
		},
		onLoaded: function () {
			this.loading = false;
		}
	}
};
</script>
